import React, { useState } from 'react';
import './Contact.css';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
import { SiUpwork } from 'react-icons/si';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="contact">
      <h2 className="section-title">Get in Touch</h2>
      <div className="contact-content">
        <div className="contact-info">
          <div className="info-item">
            <h3>Let's Connect</h3>
            <div className="social-links">
              <a
                href="mailto:ytaye715@gmail.com"
                className="social-link email"
              >
                <FaEnvelope /> Email
              </a>
              <a
                href="https://www.linkedin.com/in/yohannes-taye-564852259"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link linkedin"
              >
                <FaLinkedin /> LinkedIn
              </a>
              <a
                href="https://github.com/yohannestayez"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link github"
              >
                <FaGithub /> GitHub
              </a>
              <a
                href="https://www.upwork.com/freelancers/~010b7cef8850e1b936?mp_source=share"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link upwork"
              >
                <SiUpwork /> Upwork
              </a>
            </div>
          </div>
        </div>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="5"
            ></textarea>
          </div>
          <button type="submit" className="btn">Send Message</button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
